<template>
    <!-- app -->
    <div id="ModalBooking" class="client-invite-modal">
      <!-- use the modal component, pass in the prop -->
      <modal v-if="showModal" @close="showModal = false">
        <transition name="modal">
            <div class="modal-mask">
              <div class="modal-wrap">
                  <div class="modal-dialog">
                    <div class="modal-content">

                        <div class="modal-header">
                            <button type="button" class="close" @click="closeModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="row">
                                <div class="col-xs-2">
                                    <img class="modal-logo" v-bind:src="templateDirectory + '/images/' + logo">
                                </div>
                                <div class="col-xs-8">
                                    <h3 class="modal-headline">Book with {{profile.first_name}}</h3>
                                </div>
                            </div>
                        </div>

                      <div class="modal-body">
                        <slot name="body">
                            <div class="book-screen-1">
                                <div class="modal-inner">
                                    <p>Type in your cell phone number.</p>
                                    <p>We will send you an SMS with a PIN code.</p>
                                    <div>
                                        <span>Your Phone Number</span>
                                        <div class="invite-phone-wrapper">
                                            <select id="phone-prefix" v-model="phonePrefix" tabindex="1">
                                                <option v-for="(country,index) in countries" :selected="index == 0" v-bind:value="country">{{country}}</option>
                                            </select>
                                            <input type="number" v-model="phone1" id="phone-1" class="phone-field" tabindex="2" v-on:keyup="isNumber($event,3,phone1.length)" :maxlength="3" v-on:keyup.13="clientSendInvite"><span>-</span>
                                            <input type="number" v-model="phone2" id="phone-2" class="phone-field" tabindex="3" v-on:keyup="isNumber($event,3,phone2.length)" :maxlength="3" v-on:keyup.13="clientSendInvite" v-on:keyup.delete="checkEmptyField($event,phone2.length)"><span>-</span>
                                            <input type="number" v-model="phone3" id="phone-3" class="phone-field" tabindex="4" v-on:keyup="isNumber($event,4,phone3.length)" :maxlength="4" v-on:keyup.13="clientSendInvite" v-on:keyup.delete="checkEmptyField($event,phone3.length)">
                                            <input type="hidden" name="phone-nonce" id="phone-nonce" value="">
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button id="client-send-invite" type="button" @click="clientSendInvite" class="book-button" tabindex="5">Continue</button>
                                </div>
                                <div id="invite-messages"></div>
                            </div>


                            <div class="book-screen-2" style="display: none;">
                                <h3 class="book-section-title text-center">Hello <span class="client-user-name">{{user.first_name}} {{user.last_name}}</span>!</h3>
                                <p>To confirm the identity of your account ( associated with this phone number) we sent you an SMS with a validation code. Please enter the 4 digits code:</p>

                                <div class="verifiy-code-fields text-center">
                                    <input type="number" name="code-1" id="code-1" v-model="code1" class="phone-field code-field" tabindex="6" autocomplete="false" v-on:keyup="isNumber($event,1,code1.length)"  autocomplete="off" :maxlength="1" v-on:keyup.13="checkVerificationCode">
                                    <input type="number" name="code-2" id="code-2" v-model="code2" class="phone-field code-field" tabindex="7" autocomplete="false" v-on:keyup="isNumber($event,1,code2.length)" autocomplete="off" :maxlength="1" v-on:keyup.13="checkVerificationCode" v-on:keyup.delete="checkEmptyField($event,code2.length)">
                                    <input type="number" name="code-3" id="code-3" v-model="code3" class="phone-field code-field" tabindex="8" autocomplete="false" v-on:keyup="isNumber($event,1,code3.length)" autocomplete="off" :maxlength="1" v-on:keyup.13="checkVerificationCode" v-on:keyup.delete="checkEmptyField($event,code3.length)">
                                    <input type="number" name="code-4" id="code-4" v-model="code4" class="phone-field code-field" tabindex="9" autocomplete="false" v-on:keyup="isNumber($event,1,code4.length)" autocomplete="off" :maxlength="1" v-on:keyup.13="checkVerificationCode" v-on:keyup.delete="checkEmptyField($event,code4.length)">
                                </div>
                                <div class="text-center">
                                    <button id="check-verification-code" type="button" class="book-button" @click="checkVerificationCode" tabindex="10">Continue</button>
                                    <a class="book-back-button" href="#" data-current=".book-screen-2" @click="goBackBookingModals('book-screen-2','book-screen-1')">&lt; Go Back</a>
                                </div>
                                <div id="code-messages"></div>
                            </div>

                            <div class="book-screen-3" style="display: none;">
                                <h3 class="book-section-title text-center">Hello <span class="client-user-name">{{user.first_name}}</span>!</h3>
                                <p>Thank you for confirming the phone number!</p>
                                <p>Please check if your record is up to date:</p>

                                <div class="book-user-fields">
                                    <div class="row">
                                        <div class="col-sm-3 book-field-label">First Name:</div>
                                        <div class="col-sm-9">
                                            <input type="text" name="first-name" id="user-first-name" v-model="userFirstName" class="book-user-field" placeholder="First name">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-3 book-field-label">Last Name:</div>
                                        <div class="col-sm-9">
                                            <input type="text" name="last-name" id="user-last-name" v-model="userLastName" class="book-user-field" placeholder="Last Name">
                                        </div>
                                    </div>
                                    <div class="row" id="user-email-row">
                                        <div class="col-sm-3 book-field-label">Email:</div>
                                        <div class="col-sm-9">
                                            <input type="text" name="email" id="user-email" v-model="userEmail" class="book-user-field" placeholder="Email">
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <a class="book-link-button" v-if="user.id" @click="goToBook" id="go-to-book" href="#">Looks good!</a><br>
                                    <a class="book-link-button" @click="saveClientUser" id="save-client-user" href="#">Save and Continue</a>
                                </div>
                                <div id="save-user-messages"></div>
                            </div>



                            <div class="book-screen-blocked" style="display: none;">
                                <p>{{profile.first_name}} is not accepting online booking.</p>
                                <p>You will be redirected to home page in <span class="count-down">5</span></p>
                            </div>

                            <div class="book-screen-success" style="display: none;">
                                <p>Thank you <span class="client-user-name">{{user.first_name}}</span>!</p>
                                <p>Your appointment was scheduled for <span id="appt-date">{{booking_date}}</span> at <span id="appt-time">{{booking_hour}}</span></p>
                                <p>As soon as {{profile.first_name}} will confirm your appointment you will receive an SMS with the confirmation.</p>
                                <div class="text-center">
                                    <a class="book-link-button" id="reset-button" @click="resetButton" href="#">Thank you!</a>
                                </div>
                            </div>

                            <div class="book-screen-one-found" style="display: none;">
                                <p>We found an appointment with {{profile.first_name}} for <span id="appt-date-existing"></span> at <span id="appt-time-existing"></span> and you just scheduled this one for <span id="appt-date-new">{{book_date}}</span> at <span id="appt-time-new">{{booking_hour}}</span>.</p>
                                <p>Are you sure you want to complete this booking?</p>
                                <div class="row">
                                    <div class="col-sm-8 col-sm-offset-2">
                                        <span class="book-link-button pull-left" id="save-book-button" @click="saveAppointment">Yes. Book It!</span>
                                        <span class="book-link-button pull-right book-back-button" id="cancel-book-button" @click="cancelBookButton">Ups... Cancel it!</span>
                                    </div>
                                </div>
                                <div class="appointment-messages"></div>
                                <br>
                            </div>

                            <div class="book-screen-more-found" style="display: none;">
                                <p>We found 2 appointments with {{profile.first_name}} in less than 5 days. Please contact {{profile.first_name}}</p>
                                <p>We won’t process your booking request at this time.</p>
                                <p>You will be redirected to home page in <span class="count-down-book">5</span></p>
                            </div>




                            <div class="book-wrapper hidden">
                                <div class="book-step active">
                                    <div class="row">
                                        <div class="col-xs-2 col-sm-1 book-section-icon-wrapper">
                                            <span class="book-section-icon date book-tab-action" @click="stepsClick('calendar-wrapper')" data-section="calendar-wrapper">1</span>
                                        </div>
                                        <div class="col-xs-10 col-sm-11 book-section-header book-tab-action date" @click="stepsClick('calendar-wrapper')" data-section="calendar-wrapper">
                                            <h4 class="book-section-title">Select date</h4>
                                            <p class="book-section-subtitle" id="selected-date-label" data-placeholder="Please select a date before you can continue.">Please select a date before you can continue.</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="book-section-content calendar-wrapper">
                                                <div id="book-calendar" class="book-caledar-wrapper"><datepicker @selected="getStylistFreeHours" :inline="true" :disabledDates="disabledDates"></datepicker></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="book-step">
                                    <div class="row">
                                        <div class="col-xs-2 col-sm-1 book-section-icon-wrapper">
                                            <span class="book-section-icon book-tab-action hours" @click="stepsClick('hours-wrapper')" data-section="hours-wrapper">2</span>
                                        </div>
                                        <div class="col-xs-10 col-sm-11 book-section-header book-tab-action hours" @click="stepsClick('hours-wrapper')" data-section="hours-wrapper">
                                            <h4 class="book-section-title">Select time</h4>
                                            <p class="book-section-subtitle" id="selected-hour-label" data-placeholder="Please select an hour before you can continue.">Please select an hour before you can continue.</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="book-section-content hours-wrapper" style="display: none;">
                                                <ul id="free-hours-list" class="free-hours-list">
                                                    <li v-for="free_hour in free_hours" v-bind:class="{ selected: booking_hour==free_hour }" v-on:click="selectFreeHour(free_hour)">{{free_hour}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="book-step">
                                    <div class="row">
                                        <div class="col-xs-2 col-sm-1 book-section-icon-wrapper">
                                            <span class="book-section-icon book-tab-action services" @click="stepsClick('services-wrapper-div')" data-section="services-wrapper-div">3</span>
                                        </div>
                                        <div class="col-xs-10 col-sm-11 book-section-header book-tab-action services" @click="stepsClick('services-wrapper-div')" data-section="services-wrapper-div">
                                            <h4 class="book-section-title">Select services</h4>
                                            <p class="book-section-subtitle"><span id="selected-services-count">{{booking_services.length}} </span>services</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="book-section-content services-wrapper-div" style="display: none;">
                                                <div class="services-book-list">
                                                    <div v-for="(services,index) in profile.servicesBooking">
                                                        <h3 class="service-category-headline">{{index}}</h3>
                                                        <ul class="category-services-list">
                                                            <li v-for="service in services">
                                                                <span class="service-title">{{service.name}}</span>
                                                                <label class="switch"><input type="checkbox" class="book-service" :value="service.id" v-model="booking_services" @change="checkService($event)"><span class="slider round"></span></label>
                                                                <p class="service-desc">{{service.price}} {{service.separator}} {{service.duration}}</p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                
                                                <button id="continue-book-services" type="button" class="book-button" disabled v-on:click="continueBookServices">Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="book-step">
                                    <div class="row">
                                        <div class="col-xs-2 col-sm-1 book-section-icon-wrapper">
                                            <span class="book-section-icon book-tab-action confirmation" @click="stepsClick('confirmation')" data-section="confirmation">4</span>
                                        </div>
                                        <div class="col-xs-10 col-sm-11 book-section-header book-tab-action confirmation" @click="stepsClick('confirmation')" data-section="confirmation">
                                            <h4 class="book-section-title">Confirmation</h4>
                                            <p class="book-section-subtitle">Confirm your booking</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="book-section-content confirmation" style="display: none;">
                                                <div>
                                                    <input type="checkbox" id="special-event" :value="1" v-model="booking_special_event">
                                                    <label for="special-event" class="inline-label">Special Event</label>
                                                </div>
                                                <div>
                                                    <textarea class="book-notes-text" v-model="booking_notes">Thanks and see you soon!</textarea>
                                                </div>
                                                <div class="reminders-section-wrapper">
                                                    <h4 class="book-section-headline">Reminders (Days before appointment)</h4>
                                                    <div class="row">
                                                        <div class="col-xs-2 reminder-col-header">1</div>
                                                        <div class="col-xs-2 reminder-col-header">3</div>
                                                        <div class="col-xs-2 reminder-col-header">5</div>
                                                        <div class="col-xs-2 reminder-col-header">10</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-xs-2 text-center">
                                                            <label class="switch"><input type="checkbox" v-model="booking_reminders" :value="1" class="appt-reminder"><span class="slider round"></span></label>
                                                        </div>
                                                        <div class="col-xs-2 text-center">
                                                            <label class="switch"><input type="checkbox" v-model="booking_reminders" :value="3" class="appt-reminder"><span class="slider round"></span></label>
                                                        </div>
                                                        <div class="col-xs-2 text-center">
                                                            <label class="switch"><input type="checkbox" v-model="booking_reminders" :value="5" class="appt-reminder"><span class="slider round"></span></label>
                                                        </div>
                                                        <div class="col-xs-2 text-center">
                                                            <label class="switch"><input type="checkbox" v-model="booking_reminders" :value="10" class="appt-reminder"><span class="slider round"></span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button id="save-appointment" type="button" @click="bookNow" class="book-button">Book Now</button>
                                                <div class="appointment-messages" style="margin-top: 20px;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </transition>
        <h3 slot="header">custom header</h3>
      </modal>
    </div>
</template>

<script>
    import $ from 'jquery'
    import {eventBus} from "../main"
    import Datepicker from 'vuejs-datepicker';
    import moment  from 'moment'


    export default {
        name: 'ModalBooking',
        data() {
            return {
                admin_url: document.getElementById('admin_url').value,
                stylist_alias: document.getElementById('stylist_alias').value,
                profile: {},
                logo: '',
                templateDirectory: '',
                loading: true,
                showModal: false,
                countries: {},
                phonePrefix: '+1',
                phone: '',
                phone1: '',
                phone2: '',
                phone3: '',
                code1: '',
                code2: '',
                code3: '',
                code4: '',
                nonce: '',
                link: {},
                user: {},
                userFirstName: '',
                userLastName: '',
                userEmail: '',
                user_token: '',
                free_hours: [],
                booking_date: '',
                booking_date_existing: '',
                booking_notes: 'Thanks and see you soon!',
                booking_reminders: [],
                booking_client_id: 0,
                booking_hour: '',
                booking_hour_existing: '',
                booking_services: [],
                booking_special_event: 0,
                reminders: '',
                booking_status: 'unconfirmed',
                steps: ['calendar-wrapper'],
                agent: '',
                weekDays: ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
                disabledDates: {
                    to: new Date(Date.now() - 8640000)
                }
            }
        },
        props: {
            profile: Object,
            logo: String,
            templateDirectory: String,
            countries: Object,
            showModal: String
        },

        components: {
            Datepicker
        },

        created () {
            this.profile = this.$props.profile
            this.logo = this.$props.logo
            this.templateDirectory = this.$props.templateDirectory
            this.countries = this.$props.countries
            this.nonce = document.getElementById("phone-nonce").value
            this.agent = document.getElementById("agent").value
        },

        mounted() { 
            let self = this;
            this.disabledDates.days = [];
            this.weekDays.forEach(function(day, i){
                if(self.profile.work_settings[day] == 0){
                    self.disabledDates.days.push(i);
                }
            });
        },

        methods: {
            closeModal() {
                this.showModal = false;
                eventBus.$emit('updateShowModalState',false)
            },

            resetButton() {
                $('.book-screen-success').hide();
                $('.book-screen-1').show();
                this.resetFields();
            },

            cancelBookButton() {
                $('.book-screen-1').show();
                $('.book-screen-one-found').hide();
                this.resetFields();
            },

            stepsClick(section) {
                if(this.steps.includes(section)) {
                    $('.book-section-content.'+section).slideDown();
                    $('.book-section-content:not(.'+section+')').slideUp();
                }
            },

            continueBookServices() {
                this.steps.push('confirmation')
                $('.book-section-content.services-wrapper-div').slideUp().hide();
                $('.book-section-content.confirmation').slideDown().show();
                $('.book-tab-action.confirmation').addClass('active');
            },

            checkService(e) {
                if(this.booking_services.length>0) {
                    $('#continue-book-services').attr("disabled", false);
                }else {
                    $('#continue-book-services').attr("disabled", true);
                }
            },

            selectFreeHour(free_hour) {
                var self = $(this);

                $('#free-hours-list li').removeClass('selected');
                self.addClass('selected');

                this.steps.push('services-wrapper-div')

                $('.book-section-content.hours-wrapper').slideUp();
                $('.book-section-content.services-wrapper-div').slideDown();
                $('.book-tab-action.services').addClass('active');
                this.booking_hour = free_hour;
                $('#appt-time').text(free_hour);
                $('#selected-hour-label').text(free_hour);
            },

            bookNow() {
                var data = new FormData();

                data.append('action', 'check_client_existing_appointments');
                data.append('stylist_id', this.profile.id);
                data.append('client_id', this.user.id);
                data.append('date', this.booking_date);
                data.append('vue', true);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            $('#invite-messages').html('');
                            if(response.data.error==true) {
                                $('.appointment-messages').html('<br><div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                if(response.data.appts.length == 0){
                                    this.saveAppointment();
                                }
                                else if(response.data.appts.length == 1) {
                                    $('.book-wrapper').addClass('hidden');
                                    $('.book-screen-one-found').show();

                                    $('#appt-date-new').text( this.getFormatedDate(this.booking_date) );
                                    $('#appt-time-new').text( this.booking_hour );
                                    $('#appt-date-existing').text( this.getFormatedDate(response.data.appts[0].date) );
                                    $('#appt-time-existing').text( response.data.appts[0].hour );
                                    $('.appointment-messages').html('');
                                }
                                else if(response.data.appts.length > 1) {
                                    $('.book-wrapper').addClass('hidden');
                                    $('.book-screen-more-found').show();

                                    var seconds = 5;
                                    var interval = setInterval(function(){
                                        seconds--;
                                        $('.count-down-book').text(seconds);

                                        if(seconds == 0){
                                            clearInterval(interval);
                                            $('.book-screen-1').show();
                                            $('.book-screen-more-found').hide();
                                        }
                                    }, 1000);
                                    this.resetFields();
                                }
                            }
                        }
                    });
            },

            saveAppointment(){
                var data = new FormData();

                data.append('action', 'save_client_appointment');
                data.append('user_token', this.user_token);
                data.append('vue', true);

                data.append('date', this.booking_date);
                data.append('hour', this.booking_hour);
                data.append('services', this.booking_services);
                data.append('user_id', this.profile.id);
                data.append('special_event', this.booking_special_event);
                data.append('status', this.booking_status);
                data.append('notes', this.booking_notes);
                data.append('reminders', this.booking_reminders);
                data.append('client_id', this.user.id);


                $('.appointment-messages').html('');


                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('.appointment-messages').html('<div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                $('.appointment-messages').html('<div class="alert alert-success">'+response.data.msg+'</div>');

                                $('.book-wrapper').addClass('hidden');
                                $('.book-screen-success').show();
                                $('.book-screen-one-found').hide();
                            }
                        }
                    });
            },

            resetFields(){
                this.phone = ''
                this.phone1 = ''
                this.phone2 = ''
                this.phone3 = ''
                this.code1 = ''
                this.code2 = ''
                this.code3 = ''
                this.code4 = ''
                this.link = {}
                this.user = {}
                this.free_hours = []
                this.booking_date = ''
                this.booking_notes = 'Thanks and see you soon!'
                this.booking_reminders = []
                this.booking_client_id = 0
                this.booking_hour = ''
                this.booking_services = []
                this.booking_special_event = 0
                this.reminders = ''
                this.steps = ['calendar-wrapper']

                $('button[data-dismiss="modal"]').click();
                $('[data-section=calendar-wrapper]').click();
                $('#selected-date-label').text( $('#selected-date-label').data('placeholder') );
                $('#selected-hour-label').text( $('#selected-hour-label').data('placeholder') );
                $('.book-tab-action').removeClass('active');

                $('#invite-messages').html('');
                $('.appointment-messages').html('');
                $('#appointment-messages').html('');
                $('#code-messages').html('');
                $('#save-user-messages').html('');
            },

            getStylistFreeHours(date) {
                var formatedDate = this.customFormatter(date);
                var data = new FormData();
                data.append('action', 'get_stylist_free_hours');
                data.append('stylist_id', this.profile.id);
                data.append('user_token',this.user_token);
                data.append('date',formatedDate);

                this.booking_date = formatedDate;

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#appointment-messages').html('<div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                this.free_hours = response.data.res.free_hours

                                this.steps.push('hours-wrapper')

                                $('.book-section-content.calendar-wrapper').slideUp();
                                $('.book-section-content.hours-wrapper').slideDown();
                                $('.book-tab-action.date, .book-tab-action.hours').addClass('active');
                                //appointmentData.date_time = date;
                                $('#appt-date').text( this.getFormatedDate(date) );
                                $('#selected-date-label').text( this.getFormatedDate(date) );
                            }
                        }
                    });
            },

            customFormatter(date) {
                return moment(date).format('YYYY-MM-DD');
            },

            getFormatedDate(date) {
                return moment(date).format('dddd MMM DD');
            },

            clientSendInvite() {
                this.phone = this.phone1+''+this.phone2+''+this.phone3

                var data = new FormData();
                data.append('action', 'client_send_invite');
                data.append('stylist_id', this.profile.id);
                data.append('prefix',this.phonePrefix);
                data.append('phone',this.phone);
                data.append('vue','true');
                data.append('_nonce',this.nonce);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#invite-messages').html('<div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                //$('#invite-messages').html('<div class="alert alert-success">'+response.data.msg+'</div>');
                                this.link = response.data.link
                                this.user = response.data.user
                                this.userFirstName = response.data.user.first_name
                                this.userLastName = response.data.user.last_name
                                this.userEmail = response.data.user.email
                                this.user_token = response.data.user.api_token
                                $('body').find('.book-screen-1').hide()
                                $('body').find('.book-screen-2').show()
                            }
                        }
                    });
            },

            isNumber(evt,maxLength,myLength) {
                if(this.phone3.length > 4) {
                    var newStr = this.phone3.substr(0, this.phone3.length-1);
                    this.phone3 = newStr;
                }

                if(this.code4.length > 1) {
                    var newStr = this.code4.substr(0, this.code4.length-1);
                    this.code4 = newStr;
                }

                var target = evt.srcElement;
                if (myLength == maxLength) {
                    var next = target;

                    while (next = next.nextElementSibling) {
                        if (next == null)
                            break;
                        if (next.tagName.toLowerCase() == "input") {
                            next.focus();
                            break;
                        }
                    }
                }
            },

            checkEmptyField(evt, length) {
                if(length > 0) {
                    return;
                }

                var target = evt.srcElement;

                while (target = target.previousElementSibling) {
                    if (target == null)
                        break;
                    if (target.tagName.toLowerCase() == "input") {
                        target.focus();
                        break;
                    }
                }
            },

            goBackBookingModals(current,prev) {
                $('body').find('.'+current).hide()
                $('body').find('.'+prev).show()
            }, 

            checkVerificationCode() {
                var data = new FormData();
                data.append('action', 'verify_phone_code');
                data.append('phone', this.phone); 
                data.append('code',this.code1+''+this.code2+''+this.code3+''+this.code4);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#code-messages').html('<div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                $('#code-messages').html('<div class="alert alert-success">'+response.data.msg+'</div>');

                                $('body').find('.book-screen-2').hide()
                                $('body').find('.book-screen-3').show()
                            }
                        }
                    });
            },

            goToBook() {
                this.getModalBookingData()
            }, 

            saveClientUser() { 
                var data = new FormData();
                data.append('action', 'save_client_user_portfolio');
                data.append('phone',this.phone);

                data.append('phone_prefix',this.phonePrefix);
                data.append('first_name',this.userFirstName);
                data.append('last_name',this.userLastName);
                data.append('email',this.userEmail);
                data.append('stylist_id', this.profile.id);
                if(this.user.id){
                    data.append('user_id',this.user.id);
                }

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#save-user-messages').html('<div class="alert alert-danger">'+response.data.msg+'</div>');
                            } else {
                                $('#save-user-messages').html('<div class="alert alert-success">'+response.data.msg+'</div>');
                                this.user = response.data.user;
                                this.user_token = response.data.user.api_token;
                                this.getModalBookingData()
                            }
                        }
                    });
            },

            getModalBookingData() {
                var data = new FormData();
                data.append('action', 'get_modal_booking_data');
                data.append('stylist_alias',this.stylist_alias);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            $('body').find('.book-screen-3').hide()
                            $('body').find('.book-wrapper').removeClass('hidden')
                        }
                    });
            }
        }
    }
</script>

<style>
.modal-dialog{
    overflow-y: initial !important
}
.modal-body{
    min-height: 270px;
    overflow-y: auto;
}


.book-wrapper {
    text-align: left;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-dialog {
    margin-top: 5%!important;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-inner,.book-screen-3{
    text-align: left;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 767px){
    .invite-phone-wrapper #phone-1 {
        width: 55px !important;
    }

    .invite-phone-wrapper #phone-2 {
        width: 55px !important;
    }

    .invite-phone-wrapper #phone-3 {
        width: 70px !important;
    }
}
</style>